(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('OtherEvent', OtherEvent);

    OtherEvent.$inject = ['$resource', 'DateUtils'];

    function OtherEvent ($resource, DateUtils) {
        var resourceUrl =  'api/other-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateFrom = DateUtils.convertDateTimeFromServer(data.dateFrom);
                        data.dateTo = DateUtils.convertDateTimeFromServer(data.dateTo);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
